import usePrivateAxios from '@/common/api/usePrivateAxios';
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant';
import { Mapper } from '@/common/services/mapper';
import { MetaResponse } from '@/common/types/metaResponse';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

type UseCalendarTimezonesProps<T> = {
  filters?: {
    search?: string;
    page?: number;
  };
  mapper?: (data: any) => T;
};

export const useCalendarTimezones = <T,>({
  filters: { search = '', page } = {},
  mapper = Mapper.default<T>(),
}: UseCalendarTimezonesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['calendarTimezones', search, page],
    queryFn: () => {
      return privateAxios.get('/calendar/time_zones', {
        params: {
          search,
          page,
        },
      });
    },
    select: (data: { data: { data: any[]; meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
